import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useBannerStyles = createUseStyles((theme: Theme) => {
    return {
        bannerContainer: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(0),
        },
        bannerImage: {
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            display: 'block',
        }
    };
});

export default useBannerStyles;